import { deleteIndentApi, listOfIndent } from "Api/PurchaseOrder";
import BaseButton from "Components/Base/BaseButton";
import BaseModal from "Components/Base/BaseModal";
import TableContainer from "Components/Base/BaseTable";
import DeleteModal from "Components/Base/DeleteModal";
import {
  checkStatusCodeSuccess,
  notFound,
  Search,
} from "Components/constants/Common";
import {
  PartRequiaitionLabel,
  PRIdLabel,
  ProductCodeLabel,
  QuantityLabel,
  ROIdLabel,
} from "Components/constants/PurchaseOrder";
import {
  ActionKey,
  ActionLabel,
  NewLabel,
  NoLabel,
  YesLabel,
} from "Components/constants/Role";
import { SetStateAction, useEffect, useMemo, useState } from "react";
import { StyleSheet } from "@react-pdf/renderer";
import { RiSearchLine } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ROReturnLabels } from "Components/constants/ReturnRONPO";
import {
  DO_YOU_WANT_TO_GENERATE_PR_WITH_RO,
  GENERATE_PR_TITLE,
} from "Components/constants/ROModule";

interface PurchaseOrderItem {
  id: number;
  product_quantity: number;
  received_quantity: number;
  quantity: number;
  product: {
    id: number;
    product_code: string;
    batch_no?: number;
  };
}
interface PanelDataProps {
  id: number;
  po_status: string;
  delivery_date: string;
  createdAt: string;
  store_id: number;
  authUser: {
    id: number;
    name: string;
  };
  indent_draft_id: string;
  purchaseOrderItem: PurchaseOrderItem[];
  indentItem: PurchaseOrderItem[];
}

const styles = StyleSheet.create({
  page: {
    fontSize: 11,
    flexDirection: "column",
    height: "100vh",
    width: "100%",
    fontFamily: "sans-serif",
    padding: "2%",
  },
  header: {
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    textAlign: "center",
    height: 240,
  },
  logo: {
    width: 100,
    height: 100,
    border: "1px solid #000",
  },
  table: {
    width: "100%",
    border: "1px solid #000",
  },
  headerRow: {
    backgroundColor: "#fff",
    padding: 10,
    fontSize: 20,
    fontWeight: "bold",
  },
  headRow: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#fff",
    justifyContent: "space-between",
    height: 40,
    paddingTop: 10,
  },
  headCell: {
    padding: "5px ",
    backgroundColor: "#fff",
  },
  headCell2: {
    padding: 2,
    fontWeight: "bold",
    backgroundColor: "#fff",
    fontSize: "14px",
  },
  totalQuantityText: {
    padding: 2,
    fontWeight: "bold",
    backgroundColor: "#fff",
    marginTop: "10px",
    marginRight: "10px",
    fontSize: "20px",
    textAlign: "right",
  },
  intend: {
    fontSize: "22px",
    backgroundColor: "#fff",
    marginTop: "10px",
    padding: "5px 0px 15px 0",
  },
  row: {
    flexDirection: "row",
    border: "1px solid #000",
    height: 20,
  },
  rowSpace: {
    flexDirection: "row",
    textAlign: "center",
  },
  cell: {
    flex: 1,
    padding: 8,
    backgroundColor: "white",
    border: "1px solid #000",
  },
  cellTitle: {
    flex: 1,
    padding: 8,
    fontWeight: "extrabold",
    backgroundColor: "white",
    border: "1px solid #000",
    textAlign: "center",
    color: "#000",
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 20,
    right: 20,
    width: 100,
    textAlign: "center",
    fontSize: 10,
    color: "grey",
  },
  watermark: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: 50,
    color: "rgba(0, 0, 0, 0.1)",
  },
});

const Indentation = () => {
  document.title = PartRequiaitionLabel;
  const navigate = useNavigate();
  const [customerData, setCustomerData] = useState<Array<any>>([]);
  const [customerSearchData, setCustomerSearchData] = useState<Array<any>>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [panel, setPanel] = useState(false);
  const [panelId, setPanelId] = useState<number>();
  const [panelData, setPanelData] = useState<PanelDataProps>();
  const [btnLoader, setBtnLoader] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<number>();
  const [totalNumberOfRows, setTotalNumberOfRows] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [columnName, setColumnName] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [customPageSize, setCustomPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [addPRModalOpen, setAddPRModalOpen] = useState<boolean>(false);
  const location = useLocation();

  const isPR = useMemo(
    () => location.pathname === "/partRequisition",
    [location.pathname]);

  const handleFetchSorting = (
    page: any,
    id: SetStateAction<string>,
    order: SetStateAction<string>
  ) => {
    setCurrentPage(page);
    setColumnName(id);
    setSortOrder(order);
  };
  const handleFetchData = (page: any) => {
    setCurrentPage(page);
  };

  const handleSearchValueChange = (value: any) => {
    if (value !== searchValue) {
      setCurrentPage(1);
      setSearchValue(value);
    }
  };

  const IndentColumns = useMemo(
    () => [
      {
        header: PRIdLabel,
        accessorKey: "pr_no",
        cell: (cell: any) => cell.getValue(),
        enableColumnFilter: false,
        enableSorting: false,
      },
      ...(isPR
        ? [
            {
              header: ROIdLabel,
              accessorKey: "repairOrder.ro_no",
              cell: (cell: any) => cell.getValue(),
              enableColumnFilter: false,
              enableSorting: false,
            },
          ]
        : []),
      {
        header: ProductCodeLabel,
        accessorKey: "partRequisitionItem",
        cell: (cell: any) => {
          const productCodes = cell
            .getValue()
            .map((item: any) => item?.product?.product_code)
            .join(", ");
          return productCodes;
        },
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        header: QuantityLabel,
        accessorKey: "partRequisitionItem",
        cell: (cell: any) => {
          const quantities = cell
            .getValue()
            .map((item: any) => item.qty)
            .join(", ");
          return quantities;
        },
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        header: ActionLabel,
        accessorKey: ActionKey,
        cell: (cell: any) => (
          <div className="d-flex justify-content-start enable-action gap-2 icon">
            <span className="tooltip-container">
              <i
                className={`mdi mdi-pencil-outline fs-4 text-info cursor-pointer`}
                onClick={() =>
                  isPR
                    ? navigate(
                        `/edit-partRequisition/${cell?.row?.original?.id}`,
                        { state: { ro: cell?.row?.original?.repairOrder?.id } }
                      )
                    : navigate(
                        `/editPartRequisitionWORo/${cell?.row?.original?.id}`
                      )
                }
              ></i>
              <span className="tooltip-text">{ROReturnLabels.Edit}</span>
            </span>
            {!isPR && (
              <>
                <span className="tooltip-container">
                  <i
                    className={`mdi mdi-delete-outline fs-4 text-danger cursor-pointer`}
                    onClick={() => deleteIndentModal(cell?.row?.original?.id)}
                  ></i>
                  <span className="tooltip-text">{ROReturnLabels.Delete}</span>
                </span>
                <span className="tooltip-container">
                  <i
                    className={`mdi mdi-plus fs-4 text-success cursor-pointer`}
                    onClick={() =>
                      navigate(`/addPurchaseOrder/${cell?.row?.original?.id}`)
                    }
                  ></i>
                  <span className="tooltip-text">{ROReturnLabels.make_PO}</span>
                </span>
              </>
            )}
          </div>
        ),
        enableColumnFilter: false,
        enableSorting: false,
        enablePanel: false,
      },
    ],
    [isPR]
  );

  const fetchCustomerData = () => {
    setLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      limit: customPageSize,
      isExcludePo: true,
      ...(isPR && { withRO: true }),
    };

    listOfIndent(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          setCustomerData(response.data.part_requisition);
          setTotalRecords(response.data.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);
          if (searchValue) {
            fetchSearchCustomerData();
          }
        }
      })
      .catch((error) => {
        setCustomerData([]);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };
  const fetchSearchCustomerData = () => {
    setLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      search: searchValue,
      limit: customPageSize,
      ...(isPR && { withRO: true }),
    };
    listOfIndent(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          setCustomerSearchData(response.data.part_requisition);
          setTotalRecords(response.data.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);
        }
      })
      .catch((error) => {
        setCustomerSearchData([]);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  useEffect(() => {
    if (searchValue === "") {
      setCurrentPage(1);
    }
  }, [searchValue]);

  const openDrawer = (state: boolean, data: PanelDataProps) => {
    setPanel(state);
    setPanelId(data.id);
  };

  const deleteIndentModal = (id: number) => {
    setDeleteId(id);
    setDeleteOpen(!deleteOpen);
  };

  const deleteIndent = () => {
    setBtnLoader(true);
    deleteIndentApi(Number(deleteId))
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          toast.success(resp?.message);
        } else {
          toast.error(resp?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message);
      })
      .finally(() => {
        setBtnLoader(false);
        setPanel(!panel);
        setDeleteOpen(!deleteOpen);
        fetchCustomerData();
      });
  };

  const total_quantity = panelData?.indentItem?.reduce(
    (acc: number, value: any) => {
      return (acc += value?.quantity);
    },
    0
  );

  useEffect(() => {
    if (searchValue) {
      fetchSearchCustomerData();
    } else {
      fetchCustomerData();
    }
  }, [currentPage, customPageSize, sortOrder, columnName, searchValue, isPR]);

  const handleCreatePR = () => {
    navigate("/add-partRequisition");
    setAddPRModalOpen(false);
  };

  const handleCloseModal = () => {
    navigate("/partRequisitionWORo");
    setAddPRModalOpen(false);
  };

  return (
    <div className="page-content">
      <div className="flex-grow-1 mx-3">
        <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
          <span className="fs-4 d-flex gap-4">{PartRequiaitionLabel}</span>
          <div className="d-flex align-items-center gap-2">
            <BaseButton
              className="btn btn-success"
              onClick={() => {
                isPR ? navigate("/add-partRequisition") : setAddPRModalOpen(true);
              }
              }
              children={
                <>
                  <i className="mdi mdi-plus" /> {NewLabel}
                </>
              }
            />
          </div>
        </div>
        <BaseModal open={addPRModalOpen} title={GENERATE_PR_TITLE}>
          <div>
            <h6>{DO_YOU_WANT_TO_GENERATE_PR_WITH_RO}</h6>
            <div className="modal-footer p-0">
              <BaseButton onClick={handleCreatePR} className="btn btn-success">
                {YesLabel}
              </BaseButton>

              <BaseButton onClick={handleCloseModal} className="btn btn-danger">
                {NoLabel}
              </BaseButton>
            </div>
          </div>
        </BaseModal>

        <div className="card py-2 px-4 overflow-x-auto">
          {loader || customerData.length > 0 ? (
            <TableContainer
              customPageSize={customPageSize}
              setCustomPageSize={setCustomPageSize}
              isGlobalFilter={true}
              columns={IndentColumns}
              data={searchValue ? customerSearchData : customerData || []}
              tableClass="table bg-white"
              trClass="cursor-pointer"
              manualPagination={true}
              manualFiltering={true}
              tableLoader={loader}
              hasManualPagination={true}
              SearchPlaceholder={Search}
              setDrawerOpen={openDrawer}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
              totalRecords={totalRecords}
              onSearch={handleSearchValueChange}
              totalNumberOfRows={totalNumberOfRows}
              fetchData={handleFetchData}
              fetchSortingData={handleFetchSorting}
            />
          ) : (
            <div className="py-4 text-center">
              <div>
                <span className="fs-1 text-success">
                  <RiSearchLine />
                </span>
              </div>
              <div className="mt-4">
                <h5>{notFound.dataNotFound}</h5>
                <p className="text-muted">{notFound.thereIsNoDataFound}</p>
              </div>
            </div>
          )}
        </div>
        <DeleteModal
          show={deleteOpen}
          btnLoader={btnLoader}
          onCloseClick={() => setDeleteOpen(false)}
          onDeleteClick={deleteIndent}
        />
      </div>
    </div>
  );
};

export default Indentation;
